export default {
  title: 'Tools',
  bulkRecalcTitle: 'Bulk Recalculate Model Reports',
  bulkRecalcDescription: 'Re-trigger Model Report generation for models whose report was generated within a date range. Use this to refresh reports that predate newer features.',
  afterDateLabel: 'Generated after',
  beforeDateLabel: 'Generated before',
  typesLabel: 'Model types',
  typeAdHoc: 'Ad-hoc',
  typeDiy: 'DIY',
  typeCustomEkrm: 'Custom EKRM',
  typeCustomReference: 'Custom Reference',
  batchSizeLabel: 'Concurrent models',
  maxModelsLabel: 'Max models',
  maxModelsHint: '0 = no limit',
  previewButton: 'Preview',
  matchesTitle: '{count} matching models',
  recalculateButton: 'Recalculate {count} models',
  undeterminedNote: '{count} models have a report whose generation date could not be determined and were excluded.',
  headerName: 'Model',
  headerType: 'Type',
  headerDate: 'Report date',
  headerQuality: 'Quality',
  confirmTitle: 'Confirm recalculation',
  confirmMessage: 'This will spawn a recalculation for {count} models. Continue?',
  cancel: 'Cancel',
  confirm: 'Recalculate',
  progressLabel: 'Recalculating {done} of {total} models...',
  doneMessage: 'Recalculation finished for {count} models.',
  errorMessage: 'Something went wrong. Please try again.',
  selectAtLeastOne: 'Select at least one model.',
  close: 'Close',
  deletedModelsTitle: 'Deleted Models',
  deletedModelsDescription: 'Restore models that were deleted in the last 7 days.',
  ngtorchTitle: 'ngtorch version override',
  ngtorchDescription: 'Run ngtorch from a branch or a specific commit. While it is set, every plan, model report, EKRM and DIY model you trigger boots a VM running that version instead of the one baked into the image. Only affects you, and only in this environment.',
  ngtorchBranchLabel: 'Branch',
  ngtorchCommitLabel: 'Or a commit',
  ngtorchBranchHint: 'Follows the branch: each run boots its latest commit.',
  ngtorchCommitHint: 'Full or short commit id. Pins that exact commit, and overrides the branch above.',
  ngtorchRefsTruncated: 'The branch list was cut short. Paste a commit id if the branch you want is missing.',
  ngtorchReinstallLabel: 'Reinstall package metadata',
  ngtorchReinstallHint: 'Slower. Only needed if the branch changes packaging, such as adding a new module or an entry point.',
  ngtorchDependencyWarning: 'A branch that adds or upgrades a third-party dependency cannot run this way and still needs a rebuilt image.',
  ngtorchApplyButton: 'Apply',
  ngtorchDisableButton: 'Disable override',
  ngtorchActiveTitle: 'Running on {ref}',
  ngtorchResolvedTo: 'Pinned to {sha}',
  ngtorchFollowingTitle: 'Following branch {ref}',
  ngtorchFollowingNote: 'Each run boots this branch\'s latest commit. It was last resolved to {sha}:',
  ngtorchApplied: 'ngtorch override set to {ref} ({sha}).',
  ngtorchDisabled: 'ngtorch override disabled.',
  ngtorchNotFound: '"{ref}" is not a branch, tag or commit of ngtorch.',
  ngtorchApplyError: 'Could not set the ngtorch override. Please try again.',
  ngtorchLoadRefsError: 'Could not load the ngtorch branch list.'
}
